import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Target, Clock, BarChart3 } from "lucide-react";
import { HEADING_COLOR } from "../../../constants/colors";
import ProgressJourney from "../../../components/ProgressJourney";

const FirstTimeUserHome = () => {
  const navigate = useNavigate();
  const { firstName } = useSelector((state) => state.auth);

  return (
    <div className="bg-white min-h-screen py-4 sm:py-6 md:py-8 px-3 sm:px-4 md:px-6">
      <div className="max-w-7xl mx-auto space-y-6 sm:space-y-8">
        <div className="text-center">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold px-2" style={{ color: HEADING_COLOR }}>
            Hi {firstName || "Alex"}, Let's start by understanding your AI Job Impact Score
          </h1>
        </div>

        <ProgressJourney currentStep={1} totalSteps={6} />

        <div className="max-w-4xl mx-auto px-2 ">
          <div className="bg-white border border-gray-300 hover:shadow-xl rounded-xl p-4 sm:p-6 md:p-8 shadow-sm">
            <div className="text-center space-y-4 sm:space-y-6">
              <div className="mx-auto w-16 h-16 sm:w-16 sm:h-16 bg-purple-700 rounded-xl flex items-center justify-center">
                <Target className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
              </div>

              <h2 className="text-xl sm:text-2xl font-bold text-blue-900">
                Discover Your AI Job Impact Score
              </h2>

              <div className="space-y-1 text-gray-500 text-sm sm:text-base">
                <p>Understand how AI will affect your current role and identify potential risks and opportunities.</p>
                <p>Get a personalized assessment of your job's automation risk.</p>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
                <span className="flex items-center gap-2 px-3 py-1 text-xs sm:text-sm text-gray-600 bg-purple-100 border border-gray-200 rounded-full">
                  <Clock className="w-3 h-3 sm:w-4 sm:h-4 text-purple-400" />
                  5 minutes
                </span>
                <span className="flex items-center gap-2 px-3 py-1 text-xs sm:text-sm text-gray-600 bg-blue-100 border border-gray-200 rounded-full">
                  <BarChart3 className="w-3 h-3 sm:w-4 sm:h-4 text-blue-400" />
                  Personalized Results
                </span>
              </div>

              <button
                onClick={() => {navigate("/dashboard/career-assessment/ai-job-impact-assessment");}}
                className="w-full hover:scale-105 sm:w-auto px-6 sm:px-6 py-2 sm:py-2 border border-blue-500 text-blue-500 text-sm sm:text-base font-semibold rounded-lg hover:bg-blue-50 transition-all duration-200 transform"
              >
                Generate my AI Job Impact Assessment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeUserHome;
